/**
 * `/presupuestos` ya está tomado por la pestaña de presupuesto de una escritura
 * (ver `common/utils/subtramiteNavigation.ts`), así que el módulo de presupuestos
 * independientes usa su propio prefijo.
 */
export const PRESUPUESTOS_ROUTES = {
  LISTADO: '/presupuestos-independientes',
  PLANTILLAS: '/presupuestos-independientes/plantillas',
  PLANTILLA_DETALLE: '/presupuestos-independientes/plantillas/:id',
  DETALLE: '/presupuestos-independientes/:id',
} as const;

export const rutaDetallePresupuesto = (id: string): string =>
  `/presupuestos-independientes/${id}`;

export const rutaDetallePlantilla = (id: string): string =>
  `/presupuestos-independientes/plantillas/${id}`;
